class ClearCondition {
  constructor(
    value,
    operator,
    formattedCondition,
    formattedValue,
  ) {
    this.value = value;
    this.operator = operator;
    this.formattedCondition = formattedCondition;
    this.formattedValue = formattedValue;
  }
}
export default ClearCondition;
